import React, { Component } from 'react';
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';


let noSelected = true;
let status = undefined;
let codeId;

class RadioButtonCodigoGeografico extends Component {

    constructor(props) {
        super(props);
        this.changeInput = this.changeInput.bind(this);
        this.changeRadio = this.changeRadio.bind(this);
    }

    changeInput(event) {
        this.props.changeInput("CODIGO_GEOGRAFICO", event.target.value)
    }

    changeRadio(event) {
        this.props.changeRadio("CODIGO_GEOGRAFICO", event.target.value);
    }

    render() {
        let nodes;
        let localidad;
        let someTrue = true;
        let me = this;
        let errors;
        const { data, form } = this.props;
        const { getFieldProps, getFieldError } = form;
        const { GeographicCode } = data;

        let codigos;
        let errorContainer;

        let selected;
        let isChecked;

        nodes = null;

        if (data != undefined && data != "") {

            
            if (!this.props.data.edicion) {
                errorContainer = <label className="error">
                    {(errors = getFieldError('inputGeo')) ? errors.join(',') : null}</label>
            } else {
                if (data.GeographicCode == "" || data.GeographicCode == "Otro") {
                    errorContainer = <label className="error">
                        {(errors = getFieldError('inputGeo')) ? errors.join(',') : null}</label>
                } else {
                    errorContainer = <label className="error">
                        {(errors = getFieldError('inputGeo')) ?
                            this.props.form.isFieldTouched("inputGeo") ?
                                errors.join(',') : null
                            : null}</label>
                }
            }

            const { GeographicCode, CODIGO_GEOGRAFICO, GET_CODIGO_GEOGRAFICO, GET_DOMICILIOS } = data;
            let codigos
            let me = this;
            let isChecked;

            nodes = null;

            let codeId = data.GeographicCode != "" ? this.props.data.GeographicCode : 0;

            if (GET_DOMICILIOS.Direccion.hasOwnProperty('Calle') && GET_DOMICILIOS.Direccion.hasOwnProperty('Numero')) {
                localidad = "Código geográfico para " + data.GET_DOMICILIOS.Direccion.Localidad;

                if (GET_CODIGO_GEOGRAFICO !== undefined) {

                    const codigoElements = GET_CODIGO_GEOGRAFICO.filter(c => c.CodigoPostal === GET_DOMICILIOS.Direccion.CodigoPostal);
                    codigos = JSON.parse(JSON.stringify(codigoElements));

                    //codigos.push({ Id: -1, CodigoGeografico: "Otro" });
                    nodes = codigos.map(function (row,index) {
                        if (row.Id == -1) {
                            isChecked = codeId == "Otro" ? true :
                                !codigos.some(x => x.CodigoGeografico == codeId);
                        }
                        else {
                            isChecked = codeId == row.CodigoGeografico ? true : false;
                        }
                        if(data.GeographicCode == "" && Array.isArray(codigos) && codigos.length >0 ){
                            me.props.changeInput("CODIGO_GEOGRAFICO", codigos[0].CodigoGeografico)
                        } 
            

                        if (row.CodigoGeografico != "Otro") {
                            return (
                                <div className="col-md-2" key={row.Id.toString()}>
                                    <div className="container-radio radio-margin">
                                        <input
                                            value={row.CodigoGeografico}
                                            type="radio"
                                            name="rdCodigoGeografico"
                                            id={"Code" + row.Id}
                                            onChange={me.changeInput}
                                            checked={isChecked}
                                        />
                                        <label
                                            className="lbl-radio label-secondary"
                                            htmlFor={"Code" + row.Id}
                                        >
                                            {row.CodigoGeografico}
                                        </label>
                                    </div>
                                </div>
                            );
                        }
                        else {
                            return (
                                <div className="col-md-5" key={row.Id.toString()}>
                                    <div>
                                        <div className="col-md-6">
                                            <div className="container-radio radio-margin">
                                                <input value={row.CodigoGeografico} id={"Code" + row.Id}
                                                    type="radio" name="rdCodigoGeografico"
                                                    checked={isChecked}
                                                    onChange={me.changeInput} />
                                                <label className="lbl-radio label-secondary" htmlFor={"Code" + row.Id}>{row.CodigoGeografico}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <GenericInputValidate
                                                getFieldProps={isChecked ? getFieldProps('inputGeo', {
                                                    onChange(e) {
                                                        me.changeInput(e);
                                                    },
                                                    rules: [{
                                                        required: true,
                                                        message: 'Debe ingresar un código geográfico.'
                                                    }]
                                                }) : null}
                                                type="text"
                                                id="inputGeo"
                                                name="inputGeo"
                                                value={(isChecked && codeId != "Otro") ? me.props.data.GeographicCode : ""}
                                                className="form-control default-input"
                                                maxLength="12"
                                                autoComplete="off"
                                                disabled={!isChecked}
                                            />
                                            {isChecked ? errorContainer : null}
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                    });
                }
            }
            else {
                nodes = undefined;
            }
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h5>{localidad}</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8">
                        {nodes}
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="rdCodigoGeografico" generated="true" className="error"></label>
                    </div>
                </div>
            </div>
        );

    }

}

export default RadioButtonCodigoGeografico;